module.exports = __webpack_public_path__ + "static/media/aggregate_sl_results.9bf9631f.png";